import React, {useState} from 'react';
import axios from "axios";

export default function ResetPasswordChange({setResetStep, email, setEmail, code, setCode}) {

    const [errorMessage, setErrorMessage] = useState("");
    const [isResetting, setIsResetting] = useState(false);
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const resetPasswordUrl = "https://www.kipmate.com/manage/wp-json/bdpwr/v1/set-password"

    const axiosConfig = {
        params: {
            email: email,
            code: code,
            password: password
        },
    };

    const handlePasswordChange = (event) => {
        const inputPassword = event.target.value;
        setPassword(inputPassword);
    };

    const handleConfirmPasswordChange = (event) => {
        const inputConfirmPassword = event.target.value;
        setConfirmPassword(inputConfirmPassword);
    }

    const validatePassword = () => {
        if (password.length <= 8) {
            setErrorMessage("Password must be at least 8 characters long");
            return false;
        }
        if (password !== confirmPassword) {
            setErrorMessage("Passwords do not match");
            return false;
        } else {
            setErrorMessage(""); // Clear any previous error message
            return true;
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (validatePassword()) {
            setIsResetting(true);
            axios.post(resetPasswordUrl, null, axiosConfig)
                .then((response) => {
                    if (response.status === 200) {
                        setErrorMessage("");
                        setEmail("");
                        setCode("");
                        setResetStep(4);
                    }
                })
                .catch((error) => {
                    console.error(error);
                    setErrorMessage(error.response.data.message || "Something went wrong, please try again");
                })
                .finally(() => {
                    setIsResetting(false);
                });
        }
    }

    return (
        <>
            <div className=" text-lg">Enter you new password</div>

            <label className="hidden" htmlFor="password">Password</label>
            <input
                className="bg-purple-dashboard focus:outline-none focus:border-light-pink border-dark-pink rounded-lg border-2 h-14 px-4 py-2"
                type="password"
                placeholder="Password"
                id="password"
                name="password"
                value={password}
                onChange={handlePasswordChange}
            />

            <label className="hidden" htmlFor="confirm-password">Confirm password</label>
            <input
                className="bg-purple-dashboard focus:outline-none focus:border-light-pink border-dark-pink rounded-lg border-2 h-14 px-4 py-2"
                type="password"
                placeholder="Confirm Password"
                id="confirm-password"
                name="confirm-password"
                value={confirmPassword}
                onChange={handleConfirmPasswordChange}
            />

            {errorMessage !== "" ? <p className={"text-red-500 text-base mb-0"}>{errorMessage}</p> : null}

            <button onClick={handleSubmit}
                    className="bg-gold-accent hover:bg-gold-accent-hover text-white h-14 px-4 py-2 rounded-lg"
                    disabled={isResetting}
            >
                {isResetting ? 'Changing password...' : 'Change password'}
            </button>
        </>
    )
}